import type { Message } from "../../data/types";
import { APP_NAME } from "../../lib/appName";

/**
 * Who a primary-thread message is from. An agent row is always the product,
 * whatever its own `who` (chat.md), so `Message.who` alone isn't enough.
 */
export const speakerName = (m: Message): string =>
  m.role === "agent" ? APP_NAME : (m.who ?? "someone");
